function ApplicantDesktop({}: any) {
  return <>Hello. In Applicant Desktop component</>;
}

export default ApplicantDesktop;
